/**
 * Extract product id given a queryString
 * @param {string} queryString pid=211BBC811.T2007UN&quantity=2&uuid=75cfd6fb3500ebc66f8736726f
 * @returns {string|null} matched regex capture group (211BBC811.T2007UN) or null
 */
const getPidFromQueryString = (queryString) => {
  const regex = /pid=(.*?)&.*/;
  const match = regex.exec(queryString);
  return match ? match[1] : null;
};

module.exports = {
  getPidFromQueryString,
};
